export const ru = {
  scheduling: {
    status: {
      planned: 'Запланирована',
      due: 'Ждёт публикации',
      published: 'Опубликована',
      cancelled: 'Отменена',
    },
    noTime: 'без времени',
    pinned: 'закреплена',
    schemes: {
      title: 'Схемы публикации',
      subtitle: 'Куда и в каком порядке выходит пост: первый шаг — в слот, остальные — с задержкой от первого.',
      add: 'Новая схема',
      name: 'Название',
      steps: 'Шаги',
      step: 'Шаг {n}',
      channel: 'Канал',
      delay: 'Задержка от первого шага, часов',
      placement: 'Размещение',
      placements: {
        slot: 'в ближайший свободный слот',
        exact: 'ровно через задержку',
      },
      addStep: 'Добавить шаг',
      removeStep: 'Убрать шаг',
      queueCount: 'В очереди: {n}',
      empty: 'Схем пока нет',
      emptyText: 'Например: Telegram, затем Instagram через сутки.',
      needChannels: 'Сначала добавьте и включите каналы.',
      deleteConfirm: 'Удалить схему «{name}»?',
      edit: 'Изменить схему',
      summaryFirst: '{channel}',
      summaryNext: '{channel} через {hours} ч',
    },
    queue: {
      title: 'Очередь',
      subtitle: 'Готовые посты по порядку. Система раскладывает их по ближайшим свободным слотам.',
      empty: 'Очередь пуста',
      emptyText: 'Поставьте готовый пост в очередь из его карточки.',
      unplanned: 'Нет свободного слота — проверьте сетку слотов канала',
      remove: 'Убрать из очереди',
      up: 'Выше в очереди',
      down: 'Ниже в очереди',
      position: '№{n}',
    },
    calendar: {
      title: 'Календарь',
      week: 'Неделя',
      month: 'Месяц',
      view: 'Вид',
      prev: 'Назад',
      next: 'Вперёд',
      today: 'Сегодня',
      channel: 'Канал',
      allChannels: 'Все каналы',
      filter: 'Фильтр календаря',
      source: 'Показывать',
      publications: 'Публикации',
      posts: 'Посты',
      postsBy: 'Дата поста',
      byCreated: 'По созданию',
      byUpdated: 'По изменению',
      empty: 'В этом периоде публикаций нет.',
      noPosts: 'В этом периоде постов нет.',
      conflict: 'В одно время несколько публикаций канала',
      more: '+ ещё {n}',
    },
    panel: {
      title: 'План',
      notReady: 'Планировать можно пост в статусе с состоянием «готов к публикации».',
      scheme: 'Схема',
      toQueue: 'В очередь',
      exact: 'На точное время',
      at: 'Время первого шага',
      schedule: 'Запланировать',
      planned: 'Запланировано',
      inQueue: 'Пост стоит в очереди',
      noSchemes: 'Схем нет — владелец создаёт их в настройках.',
      reschedule: 'Перенести',
      unschedule: 'Снять',
      newTime: 'Новое время',
      apply: 'Применить',
    },
  },
};

export const en: typeof ru = {
  scheduling: {
    status: {
      planned: 'Scheduled',
      due: 'Ready to publish',
      published: 'Published',
      cancelled: 'Cancelled',
    },
    noTime: 'no time yet',
    pinned: 'pinned',
    schemes: {
      title: 'Publishing schemes',
      subtitle: 'Where and in what order a post goes: the first step takes a slot, the others follow with a delay.',
      add: 'New scheme',
      name: 'Name',
      steps: 'Steps',
      step: 'Step {n}',
      channel: 'Channel',
      delay: 'Delay from the first step, hours',
      placement: 'Placement',
      placements: {
        slot: 'next free slot',
        exact: 'exactly after the delay',
      },
      addStep: 'Add step',
      removeStep: 'Remove step',
      queueCount: 'In queue: {n}',
      empty: 'No schemes yet',
      emptyText: 'For example: Telegram, then Instagram a day later.',
      needChannels: 'Add and enable channels first.',
      deleteConfirm: 'Delete scheme “{name}”?',
      edit: 'Edit scheme',
      summaryFirst: '{channel}',
      summaryNext: '{channel} after {hours} h',
    },
    queue: {
      title: 'Queue',
      subtitle: 'Ready posts in order. The system places them into the nearest free slots.',
      empty: 'The queue is empty',
      emptyText: 'Add a ready post to the queue from its page.',
      unplanned: "No free slot — check the channel's slot grid",
      remove: 'Remove from queue',
      up: 'Move up',
      down: 'Move down',
      position: '#{n}',
    },
    calendar: {
      title: 'Calendar',
      week: 'Week',
      month: 'Month',
      view: 'View',
      prev: 'Previous',
      next: 'Next',
      today: 'Today',
      channel: 'Channel',
      allChannels: 'All channels',
      filter: 'Calendar filter',
      source: 'Show',
      publications: 'Publications',
      posts: 'Posts',
      postsBy: 'Post date',
      byCreated: 'By creation',
      byUpdated: 'By update',
      empty: 'No publications in this period.',
      noPosts: 'No posts in this period.',
      conflict: 'Several publications of a channel at the same time',
      more: '+ {n} more',
    },
    panel: {
      title: 'Plan',
      notReady: 'Only posts in a “ready to publish” status can be scheduled.',
      scheme: 'Scheme',
      toQueue: 'Add to queue',
      exact: 'Exact time',
      at: 'First step time',
      schedule: 'Schedule',
      planned: 'Scheduled',
      inQueue: 'The post is in the queue',
      noSchemes: 'No schemes — the owner creates them in settings.',
      reschedule: 'Reschedule',
      unschedule: 'Unschedule',
      newTime: 'New time',
      apply: 'Apply',
    },
  },
};
